import React, { useEffect, useState, useCallback } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { toast } from "sonner";

import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Mission } from "@/components/landing/Mission";
import { Audience } from "@/components/landing/Audience";
import { WhatsInside } from "@/components/landing/WhatsInside";
import { CardGallery } from "@/components/landing/CardGallery";
import { Spreads } from "@/components/landing/Spreads";
import { Tiers } from "@/components/landing/Tiers";
import { Founder } from "@/components/landing/Founder";
import { FAQ } from "@/components/landing/FAQ";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { ReserveModal } from "@/components/landing/ReserveModal";
import { AdminDashboard } from "@/components/admin/AdminDashboard";

import { fetchTiers, fetchPreorderStats } from "@/lib/api";

function Landing() {
  const [tiers, setTiers] = useState([]);
  const [shipDate, setShipDate] = useState("Fall 2026");
  const [reserveOpen, setReserveOpen] = useState(false);
  const [stats, setStats] = useState({ reserved: 0, goal: 300, percent: 0 });

  const refreshStats = useCallback(() => {
    fetchPreorderStats().then(setStats).catch(() => {});
  }, []);

  useEffect(() => {
    fetchTiers()
      .then((d) => {
        setTiers(d.tiers || []);
        if (d.ship_date) setShipDate(d.ship_date);
      })
      .catch(() => toast.error("Couldn't load the deck details."));
    refreshStats();
  }, [refreshStats]);

  const openReserve = () => setReserveOpen(true);

  return (
    <div className="App sf-grain min-h-screen bg-sf-bg text-sf-bone">
      <Navbar onReserve={openReserve} />
      <main>
        <Hero onReserve={openReserve} shipDate={shipDate} />
        <Mission />
        <Audience />
        <WhatsInside />
        <CardGallery />
        <Spreads />
        <Tiers tiers={tiers} shipDate={shipDate} stats={stats} onSelect={openReserve} />
        <Founder />
        <FAQ />
        <FinalCTA onReserve={openReserve} shipDate={shipDate} />
      </main>
      <Footer />

      <ReserveModal
        open={reserveOpen}
        shipDate={shipDate}
        onClose={() => setReserveOpen(false)}
        onReserved={refreshStats}
      />

      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

function App() {
  const path = (typeof window !== "undefined" ? window.location.pathname : "").replace(/\/+$/, "");
  if (path === "/admin") return <AdminDashboard />;
  return <Landing />;
}

export default App;
